const databaseReference = {
  'Minutes To Go': '1960-minutes-to-go',
  'The Exterminator': '1960-the-exterminator',
  'The Permutated Poems Of Brion Gysin (BBC)': '1961-bbc',
  'Anthology Of Concrete Poetry': '1967-anthology-of-concrete-poetry',
  'Sam Francis Catalogue': '1972-sam-francis-catalogue',
  'Brion Gysin Let The Mice In': '1973-let-the-mice-in',
  'The Third Mind': '1978-the-third-mind',
  Songs: '1981-songs',
  'Text-Sound Texts': '1988-text-sound-texts',
  'Self-Portrait Jumping': '1995-self-portrait-jumping',
  Mektoub: '1996-mektoub',
  'Back In No Time': '2002-back-in-no-time',
  'Tuning Into The Multimedia Age': '2002-tuning-into-the-multimedia-age',
  'The Spoken Word': '2012-the-spoken-word',
};

export default databaseReference;
